import React from "react";

const MyPage: React.FC = _ => {
  return <div>マイページ</div>;
};

export default MyPage;
